import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import DatePicker from "react-multi-date-picker";
import { apiRequest } from "../apiServices/allApi";

const $ = require("jquery");
$.Datatable = require("datatables.net");

function Earings() {

  //use for pagination..
  let [limit, setLimit] = useState(20);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };

  const [EARING, setEARING] = useState();
  const [ExportData, setExportData] = useState();
  const [Total, setTotal] = useState();
  const [TOTELEARING, setTOTELEARING] = useState();

  const Year = new Date().getFullYear();
  const Month = new Date().getMonth() + 1; // Adding 1 to the month since getMonth() returns 0-11

  const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;

  const dynamicStartDate = `${Year}/${formattedMonth}/01`;
  const dynamicEndDate = `${Year}/${formattedMonth}/31`;

  const [startDate, setStartDate] = useState(dynamicStartDate);
  const [endDate, setEndDate] = useState(dynamicEndDate);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
  };

  const exportData = async () => {
    const access_token = localStorage.getItem("token");
    setLoading(true);
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/Earning/export?&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`,
        "GET",
        null,
        headers,
      );
      setLoading(false);
      setExportData(res.data.admin);
      setTotal(res.data);
    } catch (error) {
      setLoading(false);
    } finally {
      const res = await apiRequest(`admin/Earning/total`, "GET", null, headers);
      setLoading(false);
      setTOTELEARING(res.data.total);
    }
  };

  useEffect(() => {
    const access_token = localStorage.getItem("token");
    setLoading(true);
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const fetchData = async () => {
      try {
        const res = await apiRequest(
          `admin/Earning?page=${pageNumber}&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`,
          "GET",
          null,
          headers,
        );
        setLoading(false);
        setEARING(res.data.admin);
        setNumberOfPages(res.data.totalPages);
      } catch (error) {
        setLoading(false);
      } finally {
        const res = await apiRequest(
          `admin/Earning/total`,
          "GET",
          null,
          headers,
        );
        setLoading(false);
        setTOTELEARING(res.data.total);
      }
    };

    fetchData();
    exportData();
  }, [pageNumber, limit, startDate, endDate]);

  const dateFormat = (e) => {
    const date = new Date(e);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // convert to 12-hour format

    return `${day}-${month}-${year} at ${hours}:${minutes} ${ampm}`;
  };

  const createDownloadData = () => {
    handleExport();
    exportData();
  };
  const handleExport = () => {
    let table1 = [
      {
        A: "id",
        B: "Amount",
        // F:"Bonus by (ID)"
      },
    ];

    ExportData?.forEach((row) => {
      const Earing = row;
      table1.push({
        A: `Earn From Challange ${Earing.Earned_Form} on ${dateFormat(Earing.createdAt)}`,
        B: Earing.Ammount,
        // F:(userDetails.action_by)?userDetails.action_by:'N/A'
      });
    });

    //table1 = [{A:"User Details"}].concat(table1);
    /* convert state to workbook */
    const ws = XLSX.utils.json_to_sheet(table1, {
      skipHeader: true,
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, "AdminEarning.xlsx");
  };

  return loading ? (
    null
  ) : (
    <>
      <div className="row mt-4">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body p-2">
              <div className="mt-2 mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                  <h4 className="dashboard_heading mb-0">
                    <i className="mdi mdi-cash text-success mr-2"></i> Admin
                    Total Earnings :{" "}
                    <span className="text-success">₹{TOTELEARING}</span>
                  </h4>
                  <div className="d-flex align-items-center">
                    {Total?.totalAmount && (
                      <span
                        className="badge badge-info p-2 mr-2"
                        style={{ fontSize: "14px" }}
                      >
                        Filtered Total: ₹{Total.totalAmount}
                      </span>
                    )}
                    <button
                      onClick={() => {
                        createDownloadData();
                      }}
                      className="btn btn-primary btn-sm"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <i className="mdi mdi-download mr-1"></i> Export Data
                    </button>
                  </div>
                </div>

                <div className="admin-filter-bar">
                  <DatePicker
                    selected={startDate}
                    value={startDate}
                    onChange={handleStartDateChange}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="Start Date"
                    className="form-control"
                  />
                  <span className="admin-filter-separator">to</span>
                  <DatePicker
                    selected={endDate}
                    onChange={handleEndDateChange}
                    value={endDate}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="End Date"
                    minDate={startDate}
                    className="form-control"
                  />

                  <select
                    className="form-control"
                    
                    id="pagelimit"
                    name="pagelimit"
                    value={limit}
                    onChange={setpageLimit}
                  >
                    <option value="10">10 / page</option>
                    <option value="20">20 / page</option>
                    <option value="50">50 / page</option>
                    <option value="100">100 / page</option>
                    <option value="500">500 / page</option>
                  </select>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> _id </th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {EARING &&
                      EARING.map((Earing, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <div className="d-flex">
                              <span className="pl-2">Earn From Game</span>
                              <a
                                className="pl-2"
                                href={`view/${Earing.Game_id}`}
                              >
                                {Earing.Game_id}
                              </a>
                              <span className="pl-2">
                                on {dateFormat(Earing.createdAt)}
                              </span>
                            </div>
                          </td>

                          <td>
                            <div className="">{Earing.Ammount}</div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Earings;
